import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useClearSegmentation = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(() => dispatch({ type: 'CLEAR_TRIGGER_SEGMENTATION' }), [dispatch]);
};
